"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThresholdsConfigurator = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const userStates_1 = require("../../../types/userStates");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const ResetButton_1 = require("./ThresholdButtons/ResetButton");
const UniformDistributionButton_1 = require("./ThresholdButtons/UniformDistributionButton");
const S = __importStar(require("./ThresholdConfigurator.style"));
const ThresholdSlider_1 = __importDefault(require("./ThresholdSlider"));
const ThresholdsConfigurator = ({ resetButtonVariant, resetButtonText, uniformDistributionButtonVariant, uniformDistributionButtonText, swapIconTextPosition = false, isMobileOldStyle = false, noDisclaimers = false, useColorBoxStyle = false, useDarkBlueIcon = false, }) => {
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const { unitSymbol, currentUserSettings } = (0, mapParamsHandler_1.useMapParams)();
    const isUniformDistributionButtonVisible = currentUserSettings === userStates_1.UserSettings.ModalView ||
        currentUserSettings === userStates_1.UserSettings.CalendarView;
    (0, react_1.useEffect)(() => {
        if (errorMessage) {
            const timer = setTimeout(() => {
                setErrorMessage("");
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [errorMessage]);
    const renderSlider = () => (react_1.default.createElement(S.SliderContainer, { "$isMobileOldStyle": isMobileOldStyle },
        errorMessage && react_1.default.createElement(S.ErrorMessage, null, errorMessage),
        react_1.default.createElement(ThresholdSlider_1.default, { isMobileOldStyle: isMobileOldStyle, useColorBoxStyle: useColorBoxStyle, setErrorMessage: setErrorMessage, isUniformDistributionButtonVisible: isUniformDistributionButtonVisible })));
    return (react_1.default.createElement(react_1.default.Fragment, null, isMobile || noDisclaimers ? (react_1.default.createElement(react_1.default.Fragment, null,
        renderSlider(),
        react_1.default.createElement(S.ThresholdButtonsMobileWrapper, null,
            react_1.default.createElement(S.PlaceholderButton, null),
            !uniformDistributionButtonText && react_1.default.createElement(S.PlaceholderButton, null),
            uniformDistributionButtonVariant && (react_1.default.createElement(UniformDistributionButton_1.UniformDistributionButton, { variant: uniformDistributionButtonVariant, hasErrorMessage: setErrorMessage, uniformDistributionButtonText: uniformDistributionButtonText })),
            resetButtonVariant && (react_1.default.createElement(ResetButton_1.ResetButton, { variant: resetButtonVariant, resetButtonText: resetButtonText, swapIconTextPosition: swapIconTextPosition, useDarkBlueIcon: useDarkBlueIcon }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.DesktopContainer, null,
            react_1.default.createElement(S.ThresholdsDisclaimer, null, t("thresholdConfigurator.disclaimer")),
            renderSlider(),
            react_1.default.createElement(S.Units, null,
                "(",
                unitSymbol,
                ")")),
        react_1.default.createElement(S.ThresholdButtonsWrapper, null,
            resetButtonVariant && (react_1.default.createElement(ResetButton_1.ResetButton, { variant: resetButtonVariant, resetButtonText: resetButtonText, swapIconTextPosition: swapIconTextPosition, useDarkBlueIcon: useDarkBlueIcon })),
            isUniformDistributionButtonVisible && (react_1.default.createElement(UniformDistributionButton_1.UniformDistributionButton, { hasErrorMessage: setErrorMessage })))))));
};
exports.ThresholdsConfigurator = ThresholdsConfigurator;
